import React from 'react';
import './style.scss';

function Tab({ title, active, color, onClick }) {
	return (
		<div className={`tab ${active && 'active'} ${color}`} onClick={() => onClick && onClick()}>
			<span className="tab-label">{title}</span>
		</div>
	);
}

export default Tab;
